import Media from 'client/common/components/media';

import './index.css';

export default Media;
